import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface Pais {
  id: number;
  nombre: string;
}

export interface Paises {
    paises: Pais[];
}

export interface ObtenerListadoPaisResponse extends ResponseMessageWithInternalStatus {
  paises: 
    {
      id: number,
      nombre: string
    }[]
}

export interface PaisesState {
  paises: Pais[];
  error: boolean;
  debugMessage?: any;
}

export const initialPaisesState: PaisesState = {
  paises: [],
  error: false,
  debugMessage: null
};